export const themes = {
  default: {
    thRoot: 'flex gap-10',
    thListItem: 'shrink-0 last:scroll-x-ghost-m-20 last:scroll-x-ghost-m',
    thNavTagTheme: 'reverse',
  },
};
